<template>
  <div class="ua-back-cover-promo-area">
    <div class="promo-area-row">
      <div class="promo-area-col">
        <img src="/images/branding/ua_performance.png" />
        <p>
          <a href="tel:+1.888.828.1547">1.888.828.1547</a> //
          <a href="mailto:teamsports@underarmour.com"
            >teamsports@underarmour.com</a
          >
          //
          <a target="_blank" href="https://armourhouse.underarmour.com"
            >armourhouse.underarmour.com</a
          >
        </p>
      </div>
    </div>
    <div class="promo-area-row">
      <div class="promo-area-col promo-area-col-sm">
        <img src="/images/branding/gameday_select.png" />
        <p>
          <a target="_blank" href="www.uacustomuniforms.com"
            >www.uacustomuniforms.com</a
          >
        </p>
      </div>
      <div class="promo-area-col promo-area-col-sm">
        <img src="/images/branding/armourfuse.png" />
        <p>
          <a target="_blank" href="www.underarmourteamuniforms.com"
            >www.underarmourteamuniforms.com</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackCoverUAPromoArea'
}
</script>